export default __webpack_public_path__ + "static/media/wFull_w.1276b5dd.svg";